__turbopack_context__.v({
  "button": "ComponentChat-module-scss-module__6QanXG__button",
  "fileButton": "ComponentChat-module-scss-module__6QanXG__fileButton",
});
